import React from 'react';
import { ChevronLeft } from 'lucide-react';

const DisclaimerPage = () => {
    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-50 via-gray-100 to-gray-200 dark:from-slate-950 dark:via-slate-950 dark:to-slate-950 flex justify-center py-8">
            <div className="w-full max-w-3xl px-4 lg:px-8">
                <button
                    onClick={() => window.location.hash = '/'}
                    className="inline-flex items-center text-gray-600 hover:text-gray-900 dark:text-slate-400 dark:hover:text-slate-200 font-medium mb-8 transition-colors"
                >
                    <ChevronLeft size={18} className="mr-1" />
                    Back to Home
                </button>

                <article className="bg-white dark:bg-slate-900 rounded-3xl shadow-xl p-8 md:p-12 border border-gray-200 dark:border-slate-800">
                    <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">Disclaimer</h1>

                    <div className="prose dark:prose-invert max-w-none text-gray-600 dark:text-slate-300 space-y-4">

                        <p>
                            The information provided by <strong>BrieflyCA</strong> on its website and mobile application
                            is for general informational purposes only. By using BrieflyCA, you acknowledge
                            and agree to the terms outlined in this Disclaimer.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            1. News Summaries & Accuracy
                        </h2>
                        <p>
                            BrieflyCA provides rewritten summaries of publicly available Canadian news.
                            While we strive for accuracy, clarity, and timeliness,
                            <strong>we do not guarantee</strong> that all information is complete, current,
                            or error-free. News evolves quickly, and summaries may not always reflect
                            updates made after publication.
                        </p>
                        <p>
                            Users are encouraged to visit the original publisher’s website for
                            full articles, context, and source material.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            2. No Professional Advice
                        </h2>
                        <p>
                            The content presented by BrieflyCA does not constitute legal, financial, medical,
                            political, or professional advice of any kind. Decisions should not be made solely
                            based on the summaries provided.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            3. Fair Dealing / Fair Use Notice
                        </h2>
                        <p>
                            BrieflyCA rewrites news content in accordance with Canadian
                            <strong>fair dealing</strong> principles and transformative <strong>fair use</strong>.
                            Original news articles, headlines, images, and reporting remain the property
                            of their respective copyright owners.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            4. External Links
                        </h2>
                        <p>
                            BrieflyCA may include links to third-party websites or sources. These are provided
                            for convenience only. We do not endorse or control external sites and are not
                            responsible for their content, policies, or actions.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            5. No Affiliation with Publishers
                        </h2>
                        <p>
                            BrieflyCA is an independent platform. We are not affiliated with any news broadcaster,
                            aggregator, or publisher. We do not claim ownership of third-party content and do not
                            reproduce full articles.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            6. Advertisements
                        </h2>
                        <p>
                            BrieflyCA may display non-personalized banner ads, including internal promotions.
                            We do not guarantee that ads are accurate or relevant, and we do not control
                            third-party advertising content.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            7. Limitation of Liability
                        </h2>
                        <p>
                            To the fullest extent permitted by law, BrieflyCA is not liable for:
                        </p>

                        <ul className="list-disc pl-5 space-y-1">
                            <li>Errors or omissions in news summaries</li>
                            <li>Decisions made based on information provided</li>
                            <li>Losses or damages arising from use of the Service</li>
                            <li>Issues related to third-party websites, data sources, or advertisers</li>
                        </ul>

                        <p>
                            You use the Service at your own risk.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            8. Changes to This Disclaimer
                        </h2>
                        <p>
                            We may update this Disclaimer from time to time. Continued use of the Service
                            indicates acceptance of the revised terms.
                        </p>

                        <h2 className="text-xl font-semibold mt-6 mb-2 text-gray-800 dark:text-slate-100">
                            9. Contact Us
                        </h2>
                        <p>
                            For questions regarding this Disclaimer, please contact:
                        </p>

                        <p>
                            📧{" "}
                            <a
                                href="mailto:info@askstudios.ca"
                                className="text-red-600 dark:text-red-400 hover:underline"
                            >
                                info@askstudios.ca
                            </a>
                        </p>

                    </div>
                </article>
            </div>
        </div>
    );
};

export default DisclaimerPage;
